import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCaCJYAexred5_uYupFQZKglsLxVkOJ4c8",
  authDomain: "aremudami-luxury.firebaseapp.com",
  projectId: "aremudami-luxury",
  storageBucket: "aremudami-luxury.appspot.com",
  messagingSenderId: "400299686587",
  appId: "1:400299686587:web:55b796f158ccf7a8dc479e",
  measurementId: "G-XZBC0E1XCD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
